import React from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import ParentLayout from '../Layout';
import Navigation from '../../../dialogs_common/Navigation';
import Urls from '../Urls';
import Form from './Form';
import { PayloadStates } from '@lore/utils';
import useRouter from '../../../hooks/useRouter';

export default function Layout(props) {
  const { location, history, match } = useRouter();
  const user = useUser();
  const offer = useConnect('offer.byId', {
    id: Number(match.params.offerId)
  })

  if (offer.state === PayloadStates.FETCHING) {
    return null;
  }

  return (
    <ParentLayout
      offer={offer}
      page="Title"
      title="Give your offer a title!"
      description={(
        <>
          A unique title makes your offer stand out when educators are searching. You
          can change your title any time.
        </>
      )}
    >
      <Form
        user={user}
        offer={offer}
        navigation={(
          <Navigation v5={true} activeStep={4} steps={16}/>
        )}
        onPrevious={(newData) => history.push(Urls(offer).OBJECTIVES)}
        onNext={(newData) => history.push(Urls(offer).SUBJECTS)}
        onSkip={() => history.push(Urls(offer).SUBJECTS)}
        onExit={() => history.push(Urls(offer).OFFER_EDIT)}
      />
    </ParentLayout>
  );
};
